import { createSlice } from '@reduxjs/toolkit';

import { Location } from '../domain/interfaces/location';
import {
  createDeleteLocationReducer,
  createFetchLocationMapImageReducer,
  createFetchLocationReducer,
  createUpsertLocationReducer,
} from './reducers';

/**
 * Слайс локаций держит только **открытую** локацию и флаги мутаций.
 *
 * Перечень локаций живёт в RTK Query (`locations-api.ts`): раньше страница копила
 * страницы в общий массив, а поиск — во второй массив рядом, и `?page=7` на
 * холодный старт откатывался на первую страницу.
 */
export interface LocationsState {
  /** Локация, открытая в карточке. */
  currentLocation?: Location;

  isProcessing: boolean;
  isProcessed: boolean;
  processName?: string;
}

const initialState: LocationsState = {
  currentLocation: undefined,

  isProcessing: false,
  isProcessed: false,
};

export const LocationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createUpsertLocationReducer(builder);
    createDeleteLocationReducer(builder);
    createFetchLocationMapImageReducer(builder);
    createFetchLocationReducer(builder);
  },
});

export default LocationsSlice.reducer;
